/**
 * ページパスと日本語画面名のマッピング
 */
export const pageNameMapping: Record<string, string> = {
  "/home": "ホーム",
  "/daily-management": "日別管理表",
  "/monthly-management": "月別管理表",
  "/disposal-verification-pma": "廃棄検証（PMA）",
  "/daily-store-summary": "個店経営状況（サマリ）",
  "/daily-store-sales": "個店経営状況（売上）",
  "/daily-store-customer-count": "個店経営状況（客数）",
  "/daily-store-unit-price": "個店経営状況（客単価）",
  "/daily-store-quantity": "個店経営状況（買上点数）",
  "/daily-store-multi": "個店経営状況（複数店舗）",
  "/waste-verification": "廃棄検証",
  "/pos-analysis-summary": "POS-PMA分析_サマリ",
  "/pos-analysis-pma": "POS-PMA分析_PMA",
  "/info-class": "情報分類",
  "/pos-analysis-transition": "POS-PMA推移",
  "/assortment-analysis": "品揃え分析",
  "/affiliation-group": "所属グループ特徴",
  "/login": "ログイン",
  "/tenpo-error": "店舗権限エラー",
};

/**
 * ページパスを日本語画面名に変換する
 * @param pagePath ページパス（例: /daily-management?date=2024-01-01）
 * @returns 日本語画面名（マッピングがない場合はパスをそのまま返す）
 */
export const getPageName = (pagePath: string): string => {
  // クエリパラメータを除いたパス部分を取得
  const pathOnly = pagePath.split("?")[0];

  // マッピングから画面名を取得（見つからない場合はパスをそのまま返す）
  return pageNameMapping[pathOnly] || pagePath;
};
